import React from 'react';

const SelectLayer = ({setKey, setLayer, layerNames, load }) => {

  const handleInputChange = (e) => {
    setLayer(e.target.value)
    setKey()
    load(true)    
  }

  return (
    <select
      className="layerSelector"
      // value="INEC_2014"
      onChange={(e) => handleInputChange(e)}
    >
      <option value="" hidden>Seleccionar Mapa</option>
      {layerNames.map((layerName) => (
        <option key={layerName} value={layerName}>
          {layerName}
        </option>
      ))}
    </select>
  );
};

export default SelectLayer;